/*
 * 使用js-cookie库
 * 英文文档地址为 https://github.com/js-cookie/js-cookie/tree/latest#readme
 */
import Cookies from 'js-cookie'

// 设置默认访问令牌
const TokenKey = 'AUTH_TOKEN'
// 获取存储在Cookies中的TokenKey信息
export function getToken() {
    return Cookies.get(TokenKey)
}
// 设置存储在Cookies中的TokenKey信息
export function setToken(token) {
    return Cookies.set(TokenKey, token)
}
// 删除存储在Cookies中的TokenTey信息
export function removeToken() {
    return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/common/auth.js